import type { IProductBundleState } from './productBundle.interfaces';

export const initialState: IProductBundleState = {
  ref: { current: null },
  state: { isFetching: true, error: undefined },
  productList: [],
  productBundleDispatch: () => null,
  hasProducts: true,
  skeletons: 3,
  handleAddToCart: () => Promise.resolve(),
  handleProductCardClick: () => null,
};
